import get from 'lodash.get';
import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import { PAGE_SIZE } from '~/modules/common/const';

export const dataArguments = `
$includePermittedActionUris: Boolean!
  `;

export const PROJECT_DROPDOWN_QUERY = gql`
  query ProjectDropdownSearch($filter: ProjectFilter2, ${dataArguments}, $pagesize: Int) {
    projects(page: 1, pagesize: $pagesize, projectFilter: $filter) {
      id
      displayText
      permittedActionUris @include(if: $includePermittedActionUris)
    }
  }
`;

export const useProjectDropdownOptions = ({
  searchTerm,
  includePermissions,
  includeMyProjectsOnly = false
}) => {
  const { data, loading } = useQuery(PROJECT_DROPDOWN_QUERY, {
    fetchPolicy: 'network-only',
    variables: {
      includePermittedActionUris: Boolean(includePermissions),
      columns: ['project', 'displayText'],
      filter: {
        text: searchTerm,
        includeMyProjectsOnly
      },
      pagesize: PAGE_SIZE + 1
    },
    context: {
      debounceKey: 'project-search',
      debounceTimeout: 250
    }
  });

  const projects = loading ? [] : get(data, 'projects', []);

  return {
    projects,
    loading,
    hasMore: projects.length > PAGE_SIZE
  };
};

export default useProjectDropdownOptions;
